
// // 1.

// import React, { createContext, useEffect, useState } from 'react'
// import AxiosApi from '../api/AxiosApi';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';

// export const AuthenticationContext = createContext()
// export function AuthenticationProvider({ children }) {
//     const Navigate = useNavigate()
//     const [IsLogged, setIsLogged] = useState(false)
//     const [authLoading, setAuthLoading] = useState(true);
//     const [LoginLoading, setLoginLoading] = useState(false)
//     const [LoggedInUserInfo, setLoggedInUserInfo] = useState(null)
//     // LOGIN_NAME is LOGIN_ID
//     function userLogin(LOGIN_NAME, PW, APP_KEY) {
//         localStorage.setItem('LoginID', LOGIN_NAME)
//         setLoginLoading(true)
//         let headersList = {
//             "Accept": "/",
//             "Content-Type": "application/x-www-form-urlencoded"
//         }
//         let bodyContent = `LOGIN_NAME=${LOGIN_NAME}&PW=${PW}&APP_KEY=${APP_KEY}`;
//         AxiosApi.post('login/LoginWEB', bodyContent, headersList)
//             .then((res) => {
//                 localStorage.setItem('LoggedInUserInfo', JSON.stringify(res?.data))
//                 localStorage.setItem('LCODE', res?.data?.Loc_Code)

//                 console.log("loccode", localStorage.setItem('LCODE', res?.data?.Loc_Code))
                
//                 setLoggedInUserInfo(res?.data)
//                 setLoginLoading(false)
//                 setIsLogged(true)
//                 const loginInfoData = localStorage.getItem("pass")
//                 if(loginInfoData !="target")
//                         Navigate("/userDashboard")

//             }).catch((er) => {
//                 alert('Invalid Credentials!')
//                 console.log('err', er)
//                 setLoginLoading(false)
//             });

//     }

//     function logOut() {
//         localStorage.clear()
//         setLoggedInUserInfo(null)
//         setIsLogged(false)



//         Navigate('/login')


      
//     }

//     useEffect(() => {
//         const data = localStorage.getItem('LoggedInUserInfo')
//         const userData = JSON.parse(data)
//         if (userData) {
//            setIsLogged(true)
//             setLoggedInUserInfo(userData)
//           //  Navigate('/userDashboard')
//         } else {
//             setIsLogged(false)
//             setLoggedInUserInfo(null)
//             localStorage.clear()
//            Navigate('login')
//         }

//         setAuthLoading(false);  // ✅ Done loading
//     }, [IsLogged])

//     return (
//         <AuthenticationContext.Provider value={{ IsLogged, setLoggedInUserInfo, LoggedInUserInfo, LoginLoading, userLogin, logOut,authLoading }}>
//             {children}
//         </AuthenticationContext.Provider>
//     )
// }

// 2.

import React, { createContext, useEffect, useState } from 'react';
import AxiosApi from '../api/AxiosApi';
import { useNavigate } from 'react-router-dom';

export const AuthenticationContext = createContext();

// शुरुआती रेंडर पर सिर्फ डेटा प्राप्त करने के लिए
const getInitialUser = () => {
  if (typeof window === 'undefined') return null;

  // 1. पहले से मौजूद sessionStorage चेक करें
  const sessionData = sessionStorage.getItem("LoggedInUserInfo");
  if (sessionData) {
    try { 
      return JSON.parse(sessionData); 
    } catch (e) { 
      console.error("Error parsing session data", e); 
    }
  }

  // 2. यूआरएल (नॉर्मल या हैश दोनों) से टोकन सुरक्षित रूप से निकालें
  const currentHref = window.location.href;
  let token = null;

  if (currentHref.includes('token=')) {
    try {
      // हैश के बाद वाले क्वेरी स्ट्रिंग को पार्स करने के लिए सुरक्षित तरीका
      const queryString = currentHref.includes('?') ? currentHref.split('?')[1] : '';
      const urlParams = new URLSearchParams(queryString);
      token = urlParams.get('token');
    } catch (err) {
      // फॉलबैक तरीका अगर URLSearchParams काम न करे
      const urlParts = currentHref.split('token=');
      if (urlParts.length > 1) {
        token = urlParts[1].split('&')[0];
      }
    }
  }

  // 3. टोकन डिकोड करके स्टोर करें
  if (token) {
    try {
      const decodedData = JSON.parse(decodeURIComponent(atob(token)));
      
      // तुरंत sessionStorage में डेटा भरें ताकि राउटर इसे तुरंत एक्सेस कर सके
      sessionStorage.setItem("LoggedInUserInfo", JSON.stringify(decodedData.userInfo));
      sessionStorage.setItem("LoginID", decodedData.loginId || "");
      sessionStorage.setItem("PW", decodedData.pw || "");
      sessionStorage.setItem("LCODE", decodedData.lcode || "");

      // अगर यह बिज़नेस पैनल से लॉगिन होकर आया है, तो इसे इसी टैब के sessionStorage में स्टोर करें
      if (decodedData.isImpersonated) {
        sessionStorage.setItem("user_is_impersonated", "true");
      }

      return decodedData.userInfo;
    } catch (e) {
      console.error("Error decoding token from URL", e);
    }
  }
  return null;
};

export function AuthenticationProvider({ children }) {
  const Navigate = useNavigate();
  
  const [LoggedInUserInfo, setLoggedInUserInfo] = useState(getInitialUser);
  const [IsLogged, setIsLogged] = useState(() => !!getInitialUser());
  const [authLoading, setAuthLoading] = useState(false);
  const [LoginLoading, setLoginLoading] = useState(false);

  // 🟢 लाइव सर्वर फिक्स: हैश राउटर के पाथ को बिगाड़े बिना यूआरएल से केवल 'token' हटाना
  useEffect(() => {
    const currentHref = window.location.href;
    
    if (currentHref.includes('token=')) {
      try {
        const urlObj = new URL(currentHref.replace('/#/', '/')); // अस्थाई रूप से हैश हटाकर URL ऑब्जेक्ट पार्स करें
        const params = new URLSearchParams(urlObj.search);
        
        // केवल token पैरामीटर डिलीट करें
        params.delete('token');
        
        // नया क्वेरी स्ट्रिंग बनाएँ
        const newQuery = params.toString();
        
        // हैश राउटर का सही फॉर्मेट वापस तैयार करें
        const hashPath = window.location.hash.split('?')[0]; // जैसे: #/userDashboard
        const cleanUrl = newQuery 
          ? `${window.location.origin}/${hashPath}?${newQuery}` 
          : `${window.location.origin}/${hashPath}`;

        // ब्राउज़र की हिस्ट्री और स्टोरेज को बिना नुकसान पहुँचाए URL क्लीन करें
        window.history.replaceState(null, '', cleanUrl);
      } catch (err) {
        console.error("Failed to clean token from URL", err);
      }

      // सुरक्षित तरीके से रिएक्ट राउटर के माध्यम से डैशबोर्ड पर भेजें
      Navigate("/userDashboard", { replace: true });
    }
    setAuthLoading(false);
  }, [Navigate]);

  // यह फंक्शन सिर्फ डायरेक्ट यूजर लॉगिन के काम आएगा
  function userLogin(LOGIN_NAME, PW, APP_KEY) {
    sessionStorage.setItem("LoginID", LOGIN_NAME);
    sessionStorage.setItem("PW", PW);

    setLoginLoading(true);
    let headersList = { Accept: "/", "Content-Type": "application/x-www-form-urlencoded" };
    
    let bodyParams = new URLSearchParams();
    bodyParams.append("LOGIN_NAME", LOGIN_NAME);
    bodyParams.append("PW", PW);
    bodyParams.append("APP_KEY", APP_KEY);

    return AxiosApi.post("login/LoginWEB", bodyParams, headersList)
      .then((res) => {
        sessionStorage.setItem("LoggedInUserInfo", JSON.stringify(res?.data));
        sessionStorage.setItem("LCODE", res?.data?.Loc_Code);

        setLoggedInUserInfo(res?.data);
        setIsLogged(true);
        setLoginLoading(false);

        Navigate("/userDashboard");
        return res?.data;
      })
      .catch((er) => {
        alert("Invalid Credentials!");
        setLoginLoading(false);
        throw er;
      });
  }

  // बिना विंडो रीलोड या localStorage को छेड़े सुरक्षित लॉगआउट (सिर्फ इस टैब के लिए)
  const logOut = () => {
    sessionStorage.clear(); // सिर्फ इसी टैब का यूजर डेटा साफ़ होगा
    setLoggedInUserInfo(null);
    setIsLogged(false);
    Navigate("/login", { replace: true }); 
  };

  return (
    <AuthenticationContext.Provider
      value={{ IsLogged, setIsLogged, setLoggedInUserInfo, LoggedInUserInfo, LoginLoading, userLogin, logOut, authLoading }}
    >
      {children}
    </AuthenticationContext.Provider> 
  );  
}